var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var loaders = require('../layout/components/loaders');
var edit = require('../layout/components/edit');
var dragscroll = require('../libs/dragscroll');
var modal = require('../layout/components/modal');
var heading = require('../components/heading');
var header = require('../layout/components/header');
var rangePikaday = require('../libs/rangePikaday');
var button = require('../components/button');
const alarmsTablePagination = require('../alarms/alarmsTablePagination');
var renderEventRow = require('./eventRow');
var dateFormatQueryParams = 'MM-DD-YYYY';
var SYSTEM_EVENT_TYPES = ['Incident', 'AlarmEvent', 'CommFailure'];
var USER_EVENT_TYPES = ['Command', 'Override', 'AuthEvent', 'Comment', 'ViewEvent'];

var events = {};

events.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Events');
  document.title = 'nimrod | Events';

  ctrl.tables = {
    system: createTableState({
      prefix: 'system',
      allowedTypes: SYSTEM_EVENT_TYPES
    }),
    user: createTableState({
      prefix: 'user',
      allowedTypes: USER_EVENT_TYPES
    })
  };

  ctrl.initTables = function () {
    return Promise.all([
      ctrl.tables.system.init(),
      ctrl.tables.user.init()
    ]);
  };

  modal.on('closed', ctrl.initTables);
  ctrl.initTables();
};

events.onremove = function () {
  modal.off('closed', this.initTables);
};

function parseDates(params, startKey, endKey) {
  var dates = prop([undefined, undefined]);
  if (params[startKey] && params[endKey]) {
    dates()[0] = moment(params[startKey], dateFormatQueryParams, true);
    dates()[1] = moment(params[endKey], dateFormatQueryParams, true);
    if (!dates()[0].isValid() || !dates()[1].isValid()) {
      dates = prop([undefined, undefined]);
    }
  } else {
    var date = new Date();
    dates()[1] = moment(date.valueOf());
    date.setDate(date.getDate() - 10);
    dates()[0] = moment(date.valueOf());

    params[startKey] = dates()[0].format(dateFormatQueryParams);
    params[endKey] = dates()[1].format(dateFormatQueryParams);
    m.route.set(m.route.get().split('?')[0], params, {replace: true});
  }

  return dates;
}

function parseEventType(params, typeKey, defaultValue) {
  if (params[typeKey]) {
    return prop(params[typeKey]);
  }

  params[typeKey] = defaultValue;
  m.route.set(m.route.get().split('?')[0], params, {replace: true});
  return prop(defaultValue);
}

function createTableState(config) {
  var prefix = config.prefix;
  var allowedTypes = config.allowedTypes;
  var params = m.parseQueryString(m.route.get().split('?')[1]);
  var startKey = `${prefix}Start`;
  var endKey = `${prefix}End`;
  var typeKey = `${prefix}Type`;

  var dates = parseDates(params, startKey, endKey);
  var eventType = parseEventType(params, typeKey, 'All');

  var state = {
    prefix: prefix,
    allowedTypes: allowedTypes,
    dates: dates,
    eventType: eventType,
    isLoading: prop(false),
    loadError: prop(''),
    eventsRids: prop([]),
    eventsToShow: prop([])
  };

  state.init = function () {
    state.isLoading(true);
    state.loadError('');
    var selectedType = state.eventType();
    var finish = function () {
      state.isLoading(false);
      m.redraw();
    };

    var typeFilter = selectedType === 'All' ? (allowedTypes || []).join(',') : selectedType;

    return loaders.requestWithLoader({
      url: `/api/v1/events/rids`,
      method: 'GET',
      params: {
        start: state.dates()[0].valueOf(),
        end: state.dates()[1].valueOf(),
        type: typeFilter,
        sort: 'desc',
        limit: 2000
      }
    })
    .then(data => {
      state.eventsRids(data.map(r => r['@rid']));
      if (state.eventsRids().length === 0) { state.eventsToShow([]); }
    })
    .catch(function (error) {
      console.error('Unable to load ' + prefix + ' events:', error);
      // A failed filter must not leave old events on screen as though they
      // belonged to the newly selected range or type.
      state.eventsRids([]);
      state.eventsToShow([]);
      state.loadError('Unable to load events. Please try again.');
      return null;
    })
    .finally(finish);
  };

  return state;
}

function renderTableHeader() {
  return m('tr', [
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', [
      m('div.flex.items-center', [
        'Timestamp',
      ])
    ]),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', [
      m('div', [
        'Event Type',
      ])
    ]),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', [
      m('div', [
        'User',
      ])
    ]),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', [
      m('div', [
        'Description',
      ])
    ]),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Object'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Path'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Value'),
    m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden.w-100', '')
  ]);
}

function prettyTypeLabel(typeName) {
  if (typeName === 'AlarmEvent') return 'Alarm Event';
  if (typeName === 'AuthEvent') return 'Auth Event';
  if (typeName === 'CommFailure') return 'Comm Failure';
  return typeName;
}

function renderEventsTable(tableState, label) {
  if (!tableState) { return; }

  var startKey = `${tableState.prefix}Start`;
  var endKey = `${tableState.prefix}End`;
  var typeKey = `${tableState.prefix}Type`;
  var typeOptions = ['All'].concat(tableState.allowedTypes);
  var rows = Array.isArray(tableState.eventsToShow()) ? tableState.eventsToShow().slice() : [];
  while (rows.length < 10) {
    rows.push({});
  }

  return m('div.mb4', [
    m('div.f1.items-center', label),
    m('div.flex.pt2.pb3.items-center.flex-wrap',[
      m('div.flex.items-center.flex-wrap',[
        m('div.flex.items-center.mr3',[
          m('div.mr2', 'Range'),
          m('div.w5.mr2', [
            m(rangePikaday, {
              value: tableState.dates,
              dateFormat: 'm/d/Y h:i K',
              updateQueryParams: true,
              queryParamsNames: [startKey, endKey],
              queryParamRouteOptions: { replace: true },
              format: dateFormatQueryParams,
              updateCallback: tableState.init
            })
          ])
        ]),
        m('div.flex.items-center',[
          m('label.mr2.nowrap', 'Event Type'),
          m('select.form-control.mv2', {
            id: `eventTypeEventsSelect-${tableState.prefix}`,
            value: tableState.eventType(), 
            onchange: function(ev){
              tableState.eventType(ev.target.value);
              var params = m.parseQueryString(m.route.get().split('?')[1]);
              params[typeKey] = tableState.eventType();
              m.route.set(m.route.get().split('?')[0], params, { replace: true });
              tableState.init();
            },
            style: {
              'min-height': 'auto', 
              'border-radius': '0.375rem',
              'padding': '0.35em 0.75em',

            }
          },
          typeOptions.map(function (typeOption) {
            return m('option', {value:typeOption}, typeOption === 'All' ? 'All' : prettyTypeLabel(typeOption));
          }))
        ])
      ]),
      m('div.flex.items-center', {style: {'margin-left': 'auto'}}, [
        m('label.mr2.f5', 'Total:'),
        tableState.isLoading() ?
          m('div.br2.nowrap.mv1.mr2', { style: { 'background-color': '#262626' } }, [
            m('label.f4.ph1', '—')
          ]) :
          m('div.br2.nowrap.mv1', { style: { 'background-color': '#262626' } }, [
            m('label.f4.ph1', `${tableState.eventsRids().length || 0}`)
          ])
      ])
    ]),
    tableState.loadError() ? m('div.bg-red.white.pa2.mb3.flex.items-center.justify-between', [
      m('span', tableState.loadError()),
      m('button.ml3', {
        type: 'button',
        onclick: function () { return tableState.init(); }
      }, 'Retry')
    ]) : null,
    m('div', [
      m('div.overflow-hidden.mb3', [
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate: dragscroll}, [
            m('table.f4.pb3.narrow.w-100.mr3',[
              m('tbody', [
                renderTableHeader(),
                rows.map(eventRecord => renderEventRow(eventRecord)),
              ])
            ])
          ])
        ])
      ]),
      (()=>{
        if (tableState.eventsRids().length > 0) {
          return m(alarmsTablePagination, {
            data: [...tableState.eventsRids()],
            url: `/api/v1/events/paginated`,
            recordsToShow: tableState.eventsToShow,
            location: { '@rid': `${tableState.prefix}-events` },
            numberOfColumns: 10
          })
        } else {
          return m('div', {style: {'min-height': '56px'}});
        }
      })()
    ])
  ]);
}

events.view = function () {
  var ctrl = this;
  
  return m('div.mh3', [
    m(heading, {
      label:`Events`, 
      class:'f-subheadline mb3 pb1 display items-center',
      helpIcon: true,
      helpFileName: 'events.md',
      helpModalTitle: 'Events Help',

    }),
    renderEventsTable(ctrl.tables.system, 'System Events'),
    renderEventsTable(ctrl.tables.user, 'User Events')
  ]);
};

events.__testables = {
  createTableState: createTableState
};

module.exports = events;
